let initialStates = {

  session: {},
  Account: {},
  GuestToken: null,
  Child: {},
  Agency: {},
  CaseWorker: {},
  DefaultAgency: {},
  MyFamilies: [],
  MyChildren: [],
  JSONData: {},
  ChildrenJSONData: {},
  DashboardFamilies: [],
  DashboardFamiliesLoaded: false,
  Country: [],
  State: [],
  Video: [],
  Album: [],
  AlbumPhotosPopulated: [],
  AlbumLoaded: false,
  Blog: [],
  Letter: [],
  AlbumPhoto: {},
  ProfileDocument: {},
  ProfileDocumentList: [],
  ProfileDocConversation: {},
  PhotoDownload: [],
  DataUpdateRequest: [],
  Request: [],
  AgencyList: [],
  AgenciesRequiredPayment: [],
  Template: [],
  TemplateItem: {},
  TemplateArray: [],
  File: [],
  FileLoaded: false,
  Task: [],
  Timeline: [],
  TimelineLoaded: false,
  IsSubscriptionActive: false,
  IsSubscriptionActiveLoaded: false,
  PdfTemplate: [],
  PdfTemplateLoaded: false,
  Message: [],
  MessageLoaded: false,
  CountsLoaded: false,
  AuthorizeTransactionReport: {},
  AuthorizeNetFutureTransaction: [],
  MessageGroup: [],
  Conversation: [],
  ArchiveConversation: [],
  ConversationLoaded: false,
  AllAccount: [],
  ContactList: [],
  Human: [],
  BlogCategory: [],
  BlogSettings: [],
  VideoList: [],
  HelpVideoLoaded: false,
  Feedback: [],
  Faq: [],
  FaqLoaded: false,
  MyAgencies: [],
  Survey: [],
  ClientDomains: [],
  SurveyLoaded: false,
  SurveyCount: 0,
  EmailTemplate: [],
  WebsiteTemplate: [],
  GoogleAd: [],
  GroupCampaign: [],
  PaymentMode: [],
  Campaign: [],
  CampaignReport: [],
  CampaignDetailedReport: [],
  MenuSettings: null,
  Project: [],
  AllProject: [],
  Log: [],
  AdminDashboardCounts: {
    All: 0,
    New: 0,
    Writing: 0,
    Layout: 0,
    Video: 0,
    Messages: 0,
    Surveys: 0
  },
  SearchResult: [],
  FileCategory: [],
  appVersionList: [],
  DocumentList: [],
  AdminList: [],
  HelpFileList: [],
  Music: [],
  BadgeContact: [],
  AgencyAccount: [],
  ChildGroup: [],
  TimelineIcons: {
    'Profile Created': { icon: 'check', color: 'green' },
    'Template Selected': { icon: 'check', color: 'green' },
    'Template Deselected': { icon: 'delete', color: 'orange' },
    'Profile PDF Uploaded': { icon: 'add', color: 'blue' },
    'Profile PDF Deleted': { icon: 'delete', color: 'red' },
    'Requested Flipbook': { icon: 'hourglass_top', color: 'blue' },
    'Profile Status Changed': { icon: 'edit', color: 'blue' },
    'File(s) Uploaded': { icon: 'add', color: 'blue' },
    'File Deleted': { icon: 'delete', color: 'red' },
    'Task Started': { icon: 'hourglass_empty', color: 'orange' },
    'Task Updated': { icon: 'edit', color: 'blue' },
    'Task Completed': { icon: 'check', color: 'green' },
    'Profile Removed': { icon: 'delete', color: 'red' },
    'Request Sent': { icon: 'add', color: 'blue' },
    'Status Changed': { icon: 'edit', color: 'blue' },
    'Removed Agency': { icon: 'delete', color: 'red' }
  }
};

export const state = initialStates;




// WEBPACK FOOTER //
// ./src/store/state.js